@if (consent.bannerVisible()) {
  <div class="fr-cookie-banner" role="dialog" aria-modal="true" aria-labelledby="fr-cookie-title">
    <div class="fr-cookie-banner__panel">
      <h2 id="fr-cookie-title" class="fr-cookie-banner__title">
        {{ 'cookieBanner.title' | translate }}
      </h2>
      <p class="fr-cookie-banner__body">
        {{ 'cookieBanner.body' | translate }}
      </p>

      @if (!customized()) {
        <div class="fr-cookie-banner__actions">
          <ion-button fill="clear" (click)="consent.rejectAll()">
            {{ 'cookieBanner.decline' | translate }}
          </ion-button>
          <ion-button fill="outline" (click)="toggleCustomize()">
            {{ 'cookieBanner.customize' | translate }}
          </ion-button>
          <ion-button color="primary" (click)="consent.acceptAll()">
            {{ 'cookieBanner.accept' | translate }}
          </ion-button>
        </div>
      } @else {
        <div class="fr-cookie-banner__customize">
          <div class="fr-cookie-banner__category fr-cookie-banner__category--locked">
            <strong>{{ 'cookieBanner.technical' | translate }}</strong>
            <p>{{ 'cookieBanner.technicalDesc' | translate }}</p>
          </div>
          <ion-item lines="none" class="fr-cookie-banner__category">
            <ion-checkbox
              slot="start"
              [checked]="analyticsDraft()"
              (ionChange)="analyticsDraft.set($any($event.detail).checked)"
            ></ion-checkbox>
            <ion-label class="ion-text-wrap">
              <strong>{{ 'cookieBanner.analytics' | translate }}</strong>
              <p>{{ 'cookieBanner.analyticsDesc' | translate }}</p>
            </ion-label>
          </ion-item>
          <div class="fr-cookie-banner__actions">
            <ion-button fill="clear" (click)="dismissCustomize()">
              {{ 'cookieBanner.cancel' | translate }}
            </ion-button>
            <ion-button color="primary" (click)="save()">
              {{ 'cookieBanner.save' | translate }}
            </ion-button>
          </div>
        </div>
      }

      <div class="fr-cookie-banner__links">
        <a routerLink="/privacy-policy">{{ 'cookieBanner.privacyPolicyLink' | translate }}</a>
        <a routerLink="/cookie-policy">{{ 'cookieBanner.cookiePolicyLink' | translate }}</a>
      </div>
    </div>
  </div>
}
